/**
 * As regras da senha de quatro dígitos, transcritas de
 * `lib/core/services/passcode_rules.dart`.
 *
 * O servidor confere as duas de novo. Estas existem para a tela poder dizer o
 * que está errado sem gastar uma ida ao servidor — e, principalmente, para que
 * a porta e os Ajustes recusem exatamente a mesma lista: uma senha que a porta
 * proíbe e os Ajustes aceitam não é regra nenhuma.
 */

/**
 * As senhas que qualquer um adivinha. Uma senha de quatro dígitos que nunca
 * muda merece pelo menos este filtro.
 */
const FRACAS = new Set([
  '0000',
  '1111',
  '2222',
  '3333',
  '4444',
  '5555',
  '6666',
  '7777',
  '8888',
  '9999',
  '1234',
  '4321',
  '0123',
  '1230',
]);

export function senhaFraca(codigo: string): boolean {
  return FRACAS.has(codigo);
}

/** Quatro dígitos, nem um a mais. */
export function senhaBemFormada(codigo: string): boolean {
  return /^\d{4}$/.test(codigo);
}
